import { useEffect, useState } from 'react';
import useApi from './useApi';
import { useRotationStore } from '../context/RotationContext';
import { BerthBM } from '../types/BusinessModel/BerthBM';
import { BerthFactory } from '../factory/BerthFactory';
import { useVesselStore } from '../context/VesselContext';
import useApiEndpoints from '../context/useApiEndpoints';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import { useBerthStore } from '../context/BerthContext';
import { BerthBMV2 } from '../types/BusinessModel/BerthBMV2';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { setUnknownBerth } = useRotationStore();
    const berthFactory = new BerthFactory();
    const [lastBerthId, setLastBerthId] = useState<number | null>(null);
    const { state, getApiData } = useApi();
    const { selectedVessel } = useVesselStore();
    const { setAllBerths } = useBerthStore();

    const getBerth = (berthId: number) => {
        setLastBerthId(berthId);
        getApiData({
            endpoint: apiEndpoints['getBerth'].url,
            queryParam: buildQueryParams({ imoNumber: selectedVessel!.imoNumber, berthId }),
        });
    };

    const getAllBerths = () => {
        getApiData({
            endpoint: apiEndpoints['getAllBerths'].url,
        });
    };

    useEffect(() => {
        if (state.status === 'success') {
            if (state.endpoint === apiEndpoints['getBerth'].url) {
                const berthBM = state.result as any as BerthBM;
                if (berthBM) {
                    const berth = berthFactory.newBerth(berthBM, null);
                    setUnknownBerth(berth);
                } else if (lastBerthId) {
                    const berth = berthFactory.newEmptyBerth(lastBerthId, '???');
                    setUnknownBerth(berth);
                }
            }
            if (state.endpoint === apiEndpoints['getAllBerths'].url) {
                const bms = state.result as any as BerthBMV2[];
                const berths = berthFactory.newBerthV2List(bms);
                setAllBerths([...berths]);
            }
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return { state, getBerth, getAllBerths };
};
